import React, {FunctionComponent} from 'react';
import './HeaderCard.less';

export const HeaderCard: FunctionComponent = ({children}) => {
	return (
		<div className="header-card">
			{children}
		</div>
	);
};
